import { WIDGET_VIEW_LINKS } from "@smallstack/typesystem";
import { WidgetRegistryEntry } from "@smallstack/widget-core";

export const LinksViewWidget: WidgetRegistryEntry = {
  name: WIDGET_VIEW_LINKS,
  component: () => import("./links-view-widget.component").then((m) => m.LinksViewWidgetComponent)
};
